import { Autocomplete, TextField } from "@mui/material"

export function ConditionValueText({ value, onChange, operator }) {
    const isMulti = operator === "is any of" || operator === "is none of"

    if (isMulti) {
        const selected = Array.isArray(value) ? value : value ? [value] : []
        return (
            <Autocomplete
                multiple
                freeSolo
                options={[]}
                value={selected}
                onChange={(_, newValue) => onChange(newValue)}
                renderInput={(params) => <TextField {...params} placeholder="Type values and press Enter..." />}
            />
        )
    }

    return <TextField fullWidth value={value || ""} onChange={handleChange} placeholder="Enter text..." />

    function handleChange(e) {
        onChange(e.target.value)
    }
}
